import * as THREE from "three";
import { OBJLoader } from "three/addons/loaders/OBJLoader.js";
import type { IFileParser } from "./IFileParser";

class ObjFileParser implements IFileParser {
	readonly supportedExtensions = ["obj"] as const;

	async parse(file: File): Promise<THREE.Object3D> {
		const text = await file.text();
		const loader = new OBJLoader();
		const object = loader.parse(text);

		// Center the object at origin
		const box = new THREE.Box3().setFromObject(object);
		const center = box.getCenter(new THREE.Vector3());
		object.position.sub(center);

		object.name = object.name || file.name.split(".")[0] || "OBJ_Model";

		return object;
	}
}

export { ObjFileParser };
